module.exports = __webpack_public_path__ + "img/72338132f7382310862da933ef1a62d1.png";